import _extends from '@babel/runtime/helpers/extends';
import 'react';
import { jsx } from '@emotion/react';

function SvgGreenTeaGlyphSecondary(props) {
  return jsx("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), jsx("path", {
    d: "M29.083 23.25h7.145c.417 0 .756.336.756.75s-.339.75-.756.75h-7.145v12.604c0 .668.434 1.17.909 1.17h8.264c.411 0 .744.33.744.737a.741.741 0 0 1-.744.739h-8.264c-1.35 0-2.397-1.207-2.397-2.646V10.646C27.595 9.207 28.641 8 29.992 8h8.264c.411 0 .744.33.744.738a.741.741 0 0 1-.744.739h-8.264c-.475 0-.91.5-.91 1.17V23.25ZM16.555 24c2.708 0 5.016-2.818 5.295-6.5l-3.924.005a.747.747 0 0 1-.744-.749c0-.414.332-.75.743-.75L22.62 16c.411 0 .745.335.745.75 0 4.795-3 8.75-6.811 8.75-3.812 0-6.811-3.955-6.811-8.75S12.743 8 16.554 8c1.6 0 3.111.723 4.32 1.997.284.3.273.774-.023 1.06a.74.74 0 0 1-1.052-.023c-.941-.992-2.074-1.534-3.244-1.534-2.89 0-5.324 3.209-5.324 7.25S13.665 24 16.555 24Zm.379 5.5v9.754c0 .415-.333.75-.744.75a.747.747 0 0 1-.744-.75V29.5H9.744A.747.747 0 0 1 9 28.75c0-.414.333-.75.744-.75h12.892c.411 0 .744.336.744.75s-.333.75-.744.75h-5.702Z",
    fill: "currentColor"
  }));
}

export { SvgGreenTeaGlyphSecondary as default };
